<!-- ToDo: Needed to wrap this into a div to prevent menu from being cut off on mobile. -->
<!--<div class="force-gpu">-->
<!--  <router-outlet></router-outlet>-->
<!--</div>-->
<router-outlet></router-outlet>
